__turbopack_context__.v({
  "button": "IconButton-module-scss-module__USt1xa__button",
  "icon": "IconButton-module-scss-module__USt1xa__icon",
  "iconButton": "IconButton-module-scss-module__USt1xa__iconButton",
});
